const FTPayload = (values, state, fixedValues) => {
    const payload = {
        sendersFinancialInstitutionCode: values.sendersFinancialInstitutionCode,
        destinationInstitutionCode: values.destinationInstitutionCode,
        channelCode: values.channelCode,
        randomNumber: state.random_number,
        timestamp: fixedValues.time_stamp,
        nameEnquiryRef: values.nameEnquiryRef,
        beneficiaryAccountName: values.beneficiaryAccountName,
        beneficiaryAccountNumber: values.beneficiaryAccountNumber,
        beneficiaryBankVerificationNumber:
            values.beneficiaryBankVerificationNumber,
        beneficiaryKYCLevel: values.beneficiaryKYCLevel,
        originatorAccountName: values.originatorAccountName,
        originatorAccountNumber: values.originatorAccountNumber,
        originatorBankVerificationNumber: values.originatorBankVerificationNumber,
        transactionLocation: values.transactionLocation,
        narration: values.narration,
        paymentReference: values.paymentReference,
        amount: values.amount,
        originatorKYCLevel: values.originatorKYCLevel,
    }
    return payload
};

export default FTPayload;